import React, { useEffect, useState } from "react";
import Button from "../../../../components/common/ui/Button";
import {
  RadioInput,
  SelectInput,
  TextInput,
} from "../../../../components/common/ui/Inputs";
import Table from "../../../../components/common/table/Table";
import { history } from "../../../../_helpers";
import { categoryActions } from "../../../../_store/category.slice";
import { useDispatch, useSelector } from "react-redux";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import categorySchema from "../../../../validation/Admin/CategorySchema";
import { useLocation, useParams } from "react-router-dom";
import CustomLoader from "../../../../components/common/ui/Loader";

const CommitteeCategoryPage = () => {
  const location = useLocation();
  const [filterCategory, setFilterCategory] = useState({
    title: "",
    status: true,
  });
  const { CategoryDropdownlist } = useSelector((x) => x.category);
  const committee = location?.state?.committee;
  const committeeId = location?.state?.committee?._id;

  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}&committee=${committeeId}`
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const { categoryForm, categoryByIdList } = useSelector((x) => x.category);
  const { getCommitteeListResponse, loading: masterLoading } = useSelector(
    (x) => x?.master
  );
  const [editRow, setEditRow] = useState({});

  const [categoryID, setCategoryID] = useState(committeeId ? committeeId : "");
  const dispatch = useDispatch();
  const { ActiveStatus } = useSelector((x) => x?.dropDown);
  const [isEditMode, setIsEditMode] = useState(false);
  const [createCategory, setCreateCategory] = useState(false);

  const { categoryList, loading } = useSelector((state) => state.category);

  useEffect(() => {
    if (!committeeId) return; // avoid running without committee

    const query = new URLSearchParams({
      page: pageNo.toString(),
      committee: committeeId.toString(),
      limit: rowCountPerPage.toString(),
      ...Object.fromEntries(
        Object.entries(filterCategory).filter(([_, v]) => v !== "")
      ),
    }).toString();

    setApiParams(`?${query}`);
    dispatch(categoryActions.getCategoryList(`?${query}`));
  }, [committeeId, pageNo, rowCountPerPage]);

  // useEffect(() => {
  //   if (!committeeId || !apiParams) return;
  //   dispatch(categoryActions.getCategoryList(apiParams));
  // }, [committeeId, apiParams, dispatch]);
  useEffect(() => {
    const resetHandler = () => {
      setIsEditMode(false);
      setCreateCategory(false);
    };

    window.addEventListener("resetCommitteeCategoryPage", resetHandler);
    return () => {
      window.removeEventListener("resetCommitteeCategoryPage", resetHandler);
    };
  }, []);

  // const list = categories_List?.data?.categories;
  // const totalCount = categories_List?.data?.totalItems || 0;
  const list = categoryList?.data?.categories;
  const totalCount = categoryList?.data?.totalItems || 0;

  const columns = [
    {
      name: "Title",
      key: "title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleEditCategory(row);
            }}
          />

          <ToggleSwitch
            name={`Status${row._id}`}
            id={`Status${row._id}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleCategoryStatus(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const handleRowPerPage = (page) => {
    const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
    setApiParams(updatedParams);
    dispatch(categoryActions?.getCategoryList(updatedParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(categoryActions?.getCategoryList(updatedParams));
    setPageNo(page);
  };

  // const handleEditCategory = (row) => {
  //   // history?.navigate("/Admin/DocCategory/CreateOrEdit", {
  //   //   state: { categoryId: row?._id },
  //   // });
  //   categoryID = row?._id;
  //    const eventRow = {...row};
  //   setEditRow(eventRow);
  //   setIsEditMode(true);
  //   setCreateCategory(false);
  //   dispatch(categoryActions.updateCategoryForm(eventRow))
  // };
  const handleEditCategory = (row) => {
    // categoryID = row?._id;
    let id = row?._id;
    setCategoryID(id);
    const eventRow = {
      committee: row?.committee?._id || row?.committee,
      title: row?.title || "",
    };
    setEditRow(eventRow);
    setIsEditMode(true);
    setCreateCategory(false);
    // pass only committee + title to redux
    dispatch(categoryActions.updateCategoryForm(eventRow));
  };

  const handleCategoryStatus = (e, row) => {
    dispatch(
      categoryActions.categoryStatusChange({
        id: row?._id,
      })
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          const params = apiParams;
          dispatch(categoryActions.getCategoryList(params));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };

  const handleSearchChange = (e) => {
    debugger;
    const { name, value, type } = e.target;
    if (name === "status") {
      //
      setFilterCategory((prev) => ({
        ...prev,
        [name]: value === "true" ? true : false,
      }));
    } else {
      setFilterCategory((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const query = new URLSearchParams({
      page: "1",
      committee: committeeId?.toString(),
      limit: "10",
      ...Object.fromEntries(
        Object.entries(filterCategory).filter(([_, v]) => v !== "")
      ),
    }).toString();

    const params = `?${query}`;

    setApiParams(params); // update state
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(categoryActions.getCategoryList(params));
  };

  const handleFormReset = () => {
    const params = `?page=${1}&limit=${10}&status=${true}&committee=${committeeId}`;
    setApiParams(params);
    setFilterCategory({ title: "", status: true });
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(categoryActions?.getCategoryList(params));
    dispatch(categoryActions?.resetCategoryForm());
  };

  const handleChange = (e, select) => {
    let form = { ...categoryForm };

    if (select) {
      form[select] = e?.value;
      dispatch(categoryActions.updateCategoryForm(form));
      return;
    }
    let { name, value } = e.target;

    form[name] = value;

    dispatch(categoryActions.updateCategoryForm(form));
  };

  const handleFormSubmit = (e) => {
    e?.preventDefault();
    setIsPending(true);
    setErrorMessage({});
    const form = { ...categoryForm };
    form["committee"] = committeeId;
    const { error } = categorySchema(form);
    console.log(categoryForm);
    console.log(error?.details);

    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    //API call after validation
    const resquest = isEditMode
      ? dispatch(
          categoryActions.updateCategory({
            id: categoryID,
            data: { title: categoryForm.title, committee: committeeId },
          })
        )
      : dispatch(
          categoryActions.CreateCategory({
            committee: committeeId,
            title: categoryForm.title,
          })
        );
    resquest
      .then((result) => {
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(categoryActions.resetCategoryForm());
          handleFormReset();
          setCreateCategory(false);
          setIsEditMode(false);
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsPending(false);
      });
  };

  if (masterLoading || loading) return <CustomLoader />;

  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Documents Category</h1>
        <Button
          status="secondary"
          label="Create Documents Category"
          onClick={() => {
            history?.navigate("/Admin/DocCategory/CreateOrEdit", {
              state: { categoryId: 0 },
            });
          }}
        />
      </div> */}
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">{committee?.committeeName}</h1>
        <div className="d-flex justify-content-end">
          {/* {isEditMode ? (
          <Button
            className="me-2"
            label="Create"
            status="secondary"
            onClick={() => {
              setIsEditMode(false);
              dispatch(memberActions?.resetCommitteeMemberForm({}));
            }}
          />
        ) : null} */}

          {createCategory === false && (
            <Button
              className="me-2"
              label="Create"
              status="secondary"
              onClick={() => {
                setCreateCategory(true);
                setIsEditMode(false);
                // dispatch(postFormAction?.resetForm({}));
                dispatch(categoryActions.resetCategoryForm());
              }}
            />
          )}

          <Button
            label="Back"
            status="reset"
            onClick={() => {
              setErrorMessage({});
              isEditMode === false && createCategory === false
                ? history?.navigate("/Admin/CommitteePage")
                : setIsEditMode(false);
              setCreateCategory(false);
            }}
          />
        </div>
      </div>
      {isEditMode === false && createCategory === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            Search Documents Category
          </h1>
          <form
            className="p-3 row"
            onSubmit={(e) => {
              handleSearchSubmit(e);
            }}
            onReset={(e) => {
              handleFormReset(e);
            }}
          >
            <div className="col-md-4">
              <TextInput
                label="Title"
                placeholder="title"
                name="title"
                handleChange={handleSearchChange}
                value={filterCategory?.title}
              />
            </div>

            <div className="col-md-3">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleSearchChange(e)}
                selectedValue={filterCategory?.status}
                value={filterCategory?.status}
              />
            </div>

            <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
              <Button status="secondary" label="Search" type="submit" />
              <Button status="reset" label="Reset" type="reset" />
            </div>
          </form>
        </div>
      )}

      {(isEditMode || createCategory) && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
            {isEditMode ? "Edit" : "Create"} Category
          </h1>
          <form
            onSubmit={(e) => {
              handleFormSubmit(e);
            }}
            onReset={(e) => {
              handleFormReset(e);
            }}
            className="p-3 row"
          >
            <div className="row mb-4">
              <div className="col-md-4">
                <TextInput
                  label="Title"
                  placeholder="title"
                  name="title"
                  id="title"
                  handleChange={(e) => handleChange(e)}
                  required
                  errorMessage={errorMessage}
                  value={categoryForm?.title}
                />
              </div>
              {/* {!isEditMode && (
             {!categoryId && (
              <div className="col-md-4">
                <SelectInput
                  options={getCommitteeListResponse?.data}
                  name="committee"
                  id="committee"
                  label="Committee"
                  required
                  handleChange={(e) => handleChange(e, "committee")}
                  errorMessage={errorMessage}
                  value={categoryForm?.committee}
                />
              </div>
            )} */}
            </div>
            <div className="d-flex justify-content-center align-items-center gap-2">
              <Button
                label={`${isEditMode === false ? "Submit" : "Update"}`}
                type="submit"
                status="secondary"
                disabled={isPending}
              />
              <Button label="Reset" type="reset" status="reset" />
            </div>
          </form>
        </div>
      )}

      {isEditMode === false && createCategory === false && (
        <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
          <h1 className="m-0 search-header-color p-3 ">
            Documents Category List
          </h1>
          <Table
            columns={columns}
            data={list}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={totalCount}
            currentPage={pageNo}
            paginationPerPage={rowCountPerPage}
          />
        </div>
      )}
    </>
  );
};

export default CommitteeCategoryPage;
